import legalDocumentType from "./legalDocumentType";

export default [
  { id: legalDocumentType.W9, name: "W9" },
  { id: legalDocumentType.INSURANCE_CERTIFICATE, name: "Insurance Certificate" },
];
